module.exports = __webpack_public_path__ + "img/china_map.e795220e.png";